import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/HomeScreen.css';
import pic1 from './assets/pic1.jpg';
import pic2 from './assets/pic2.jpg';
import pic3 from './assets/pic3.jpg';
import pic4 from './assets/pic4.jpg';
import SEO from './components/SEO';

function HomeScreen() {
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('video', file);

    try {
      const response = await fetch('http://localhost:3000/recipe-add', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      navigate('/recipe-details', { state: { data } });
    } catch (error) {
      console.error('Error uploading video:', error);
    }
  };

  const goToRecipesList = () => {
    navigate('/');
  };

  return (
    <div className="home-container">
      <SEO 
        title="Savory Home - Discover Amazing Recipes"
        description="Welcome to Savory, your home for discovering amazing recipes with detailed nutritional information. Upload videos, find recipes, and explore culinary creations."
        keywords="savory home, recipe discovery, cooking videos, nutritional recipes, home cooking"
        url="/home"
        type="website"
        breadcrumb={[
          { name: "Home", url: "/" },
          { name: "Home Screen", url: "/home" }
        ]}
      />
      <div className="home-header">
        <img src="https://yt3.googleusercontent.com/9tT28FJEfax0f2GIlBqvxK5GA53zmqw3eLHrV__8q1301_5YEvOZHosdd_MR-BlXJ-4rEbBzqpU=s160-c-k-c0x00ffffff-no-rj" alt="Delicious recipe creation and cooking inspiration" className="image-style" />
        <img src={pic2} alt="Professional cooking techniques and gourmet meal preparation" className="image-style" />
        <img src={pic3} alt="Fresh ingredients and healthy recipe ingredients" className="image-style" />
        <img src={pic4} alt="Beautiful plated dishes and culinary presentation" className="image-style" />
      </div>
      <h1 className="big-title">Savory</h1>
      <div className="upload-section">
        <input type="file" accept="video/*" onChange={handleFileChange} />
        <button onClick={handleUpload}>Upload the recipe</button>
        {/* Add another button below the upload button */}
        
      </div>
      <button onClick={goToRecipesList} className="recipe-list-button">Go to Recipes List</button>
    </div>
  );
}

export default HomeScreen;
